import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const AdditionalServicesSection = ({ 
  servicesConfig, 
  onServicesConfigChange, 
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleServiceChange = (service, checked) => {
    onServicesConfigChange({
      ...servicesConfig,
      [service]: checked
    });
  };

  const services = [
    { 
      key: 'plumbingModification', 
      label: 'Modification plomberie', 
      description: 'Tarif fixe pour modifications plomberie',
      icon: 'Wrench',
      price: '150,00 €'
    },
    { 
      key: 'lightingInstallation', 
      label: 'Installation éclairage', 
      description: 'Installation spots et éclairage sous-meuble',
      icon: 'Lightbulb',
      price: '200,00 €'
    },
    { 
      key: 'electricalModification', 
      label: 'Modification électrique', 
      description: 'Tarif fixe pour modifications électriques',
      icon: 'Zap',
      price: '180,00 €'
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-success rounded-full">
            <Icon name="Settings" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Services Additionnels</h3>
            <p className="text-sm text-text-secondary">Services complémentaires avec tarifs fixes</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary" 
        />
      </div>
      {!isCollapsed && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="space-y-3 mt-4">
            {services?.map((service) => (
              <div key={service?.key} className="flex items-start space-x-3 p-4 bg-muted rounded-lg">
                <Icon name={service?.icon} size={20} className="text-text-secondary mt-1" />
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <Checkbox
                      label={service?.label}
                      checked={servicesConfig?.[service?.key] || false}
                      onChange={(e) => handleServiceChange(service?.key, e?.target?.checked)}
                    />
                    <span className="text-sm font-medium text-text-primary">{service?.price}</span>
                  </div>
                  <p className="text-xs text-text-secondary mt-1 ml-6">{service?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalServicesSection;